import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { colors } from "../../theme/theme";
import ColorSelector from "./ColorSelector";
import { useHorizontalDragScroll } from "../../utils/useHorizontalDragScroll";
import { logUserAction } from "../../utils/analytics";

const SimilarProductCard = ({
  productData,
  noColor = false,
  oneLiner = false,
  showAll = false,
}) => {
  const navigate = useNavigate();
  const innerScrollRef = useHorizontalDragScroll();

  const query = localStorage.getItem("query");

  return (
    <Box
      ref={innerScrollRef}
      className="flex overflow-x-auto"
      sx={{
        display: "flex",
        gap: 2,
        pb: 2,
        marginLeft: "-20px",
        pr: 2,
        pl: oneLiner ? 1 : 2,
        "&::-webkit-scrollbar": {
          display: "none",
        },
        ml: 0,
        pt: 0.5,
      }}
    >
      {productData.map(
        (product, index) =>
          (showAll || index !== 0) && (
            <Stack
              key={index}
              direction={"column"}
              sx={{
                ml: index === 0 ? 2 : 0,
              }}
            >
              <Card
                onClick={async () => {
                  await logUserAction({
                    action: "product_click",
                    data: {
                      product_id: product.product_id || null,
                      product_title: product.title || null,
                      brand: product.brand || null,
                      product_price:
                        product?.price?.discounted ||
                        product?.price?.original ||
                        null,
                      currency: product?.price?.currency || null,
                      product_image: product?.image_url || null,
                    },
                    timestamp: new Date().toISOString(),
                  });
                  navigate("/product", {
                    state: {
                      product: product,
                      similarProducts: productData,
                      searchQuery: query,
                    },
                  });
                }}
                sx={{
                  width: "220px",
                  borderRadius: noColor ? "18px" : "12px",
                  display: "flex",
                  flexDirection: "column",
                  boxShadow: "-1px -1px 5px 0px #00000012",
                  flexShrink: 0,
                  position: "relative",
                  transition: "all 0.3s ease-in-out",
                  "&:hover": {
                    boxShadow: "0 6px 8px rgba(0, 0, 0, 0.2)",
                  },
                  "&:active": {
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                    transform: "scale(0.98)",
                  },
                  cursor: "pointer",
                }}
              >
                <img
                  src={product.image_url}
                  onError={(e) =>
                    (e.target.src = require("../../assets/images/no_image.png"))
                  }
                  loading="lazy"
                  alt=""
                  style={{
                    objectFit: "contain",
                    height: "400px",
                  }}
                />

                <CardContent
                  className="bg-white"
                  sx={{
                    p: noColor ? 1.5 : 2,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    maxHeight: "100px",
                    overflow: "hidden",
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: "14px",
                      color: colors.textColor3,
                      fontFamily: "Poppins-SemiBold",
                      fontWeight: "600",
                      display: "-webkit-box",
                      WebkitLineClamp: oneLiner ? 1 : 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {product?.title}
                  </Typography>

                  {!noColor && <ColorSelector small />}

                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: colors.textColor3,
                      fontFamily: "Poppins-Light",
                      fontWeight: "300",
                      mt: noColor ? 0 : 1.5,
                      mb: noColor ? -1 : 0,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {product?.price?.discounted ||
                      product?.price?.original ||
                      "N/A"}{" "}
                    {product?.price?.currency || ""}
                  </Typography>
                </CardContent>
              </Card>
            </Stack>
          ),
      )}
    </Box>
  );
};

export default SimilarProductCard;
